<template>
  <b-modal
    id="modal-filters-user"
    centered
    title="Filtros"
    title-class="font-18"
    @shown="visibleCollapse"
  >
    <div class="row">
      <div class="col-12">
        <b-form-group label="Selecione o Período">
          <date-range-picker
            id="range"
            ref="picker"
            v-model="date"
            class="w-100"
            :locale-data="localeDate"
            :show-week-numbers="false"
            :show-dropdowns="true"
            :auto-apply="false"
            :ranges="dateRanges"
          >
            <template
              v-if="date.startDate && date.endDate"
              v-slot:input="picker"
            >
              {{ picker.startDate | date }} - {{ picker.endDate | date }}
            </template>
            <template v-else v-slot:input> Período </template>
          </date-range-picker>
        </b-form-group>
      </div>
    </div>

    <b-row>
      <b-col cols="6">
        <b-form-group label="Do valor">
          <b-form-input
            id="balance_start"
            v-model="balanceStart"
            type="number"
          />
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="Até o valor">
          <b-form-input id="balance_end" v-model="balanceEnd" type="number" />
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col cols="12">
        <b-form-checkbox v-model="lastMonth" name="check-button" switch>
          Considerar faturamentos do último mês
        </b-form-checkbox>
      </b-col>
    </b-row>

    <div v-b-toggle.receivers @click="collapse = !collapse" class="receivers">
      Recebedores
      <img src="@/src/assets/img/icons/chevron_right.svg" alt="chevron_right" :style="dynamicChevron">
    </div>
    <b-collapse id="receivers" :visible="OpenCollapse">

      <div class="row">
      <!-- ID Pagarme -->
      <div class="col-12 col-md-6">
        <b-form-group label="ID no Pagar.me">
          <b-form-input
          v-model="user_id_pagarme"
          type="search"
          placeholder="ID Pagar.me..."
          class="form-control form-control-sm ml-2 search_id"
          ></b-form-input>
        </b-form-group>
      </div>
      <!-- Status Pagarme -->
      <div class="col-12 col-md-6">
        <b-form-group label="Status no Pagar.me">
          <b-form-select
            v-model="status_pagarme"
            size="sm"
            :options="options_gateways"
          ></b-form-select>
        </b-form-group>
      </div>
    </div>

    <div class="row">
      <!-- ID Iugu -->
      <div class="col-12 col-md-6">
        <b-form-group label="ID no Iugu">
          <b-form-input
          v-model="user_id_iugu"
          type="search"
          placeholder="ID Iugu..."
          class="form-control form-control-sm ml-2 search_id"
          ></b-form-input>
        </b-form-group>
      </div>
      <!-- Status Iugu -->
      <div class="col-12 col-md-6">
        <b-form-group label="Status no Iugu">
          <b-form-select
            v-model="status_iugu"
            size="sm"
            :options="options_gateways"
          ></b-form-select>
        </b-form-group>
      </div>
    </div>

    <div class="row">
      <!-- ID Celcoin -->
      <div class="col-12 col-md-6">
        <b-form-group label="ID na Celcoin">
          <b-form-input
          v-model="user_id_celcoin"
          type="search"
          placeholder="ID Celcoin..."
          class="form-control form-control-sm ml-2 search_id"
          ></b-form-input>
        </b-form-group>
      </div>
      <!-- Status Celcoin -->
      <div class="col-12 col-md-6">
        <b-form-group label="Status na Celcoin">
          <b-form-select
            v-model="status_celcoin"
            size="sm"
            :options="options_celcoin"
          ></b-form-select>
        </b-form-group>
      </div>
    </div>
    </b-collapse>

    <template v-slot:modal-footer="{ cancel }">
      <b-button variant="secondary" @click="cancel">Cancelar</b-button>
      <b-button variant="success" @click="onSubmit">Ok</b-button>
    </template>
  </b-modal>
</template>

<script>
import DateRangePicker from 'vue2-daterange-picker'
import moment from 'moment'

export default {
  components: { DateRangePicker },
  data() {
    return {
      OpenCollapse:false,
      collapse:false,
      users: [],
      user_id: null,
      balanceStart: 0,
      balanceEnd: 0,
      lastMonth: false,
      date: {
        startDate: null,
        endDate: null
      },
      localeDate: {
        direction: 'ltr',
        format: 'mm/dd/yyyy',
        separator: ' - ',
        applyLabel: 'Aplicar',
        cancelLabel: 'Cancelar',
        weekLabel: 'W',
        customRangeLabel: 'Custom Range',
        daysOfWeek: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sáb'],
        monthNames: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
        firstDay: 0
      },
      user_id_celcoin:null,
      status_celcoin: null,
      options_celcoin: [
        { value: null, text: 'Todos' },
        { value: 'CONFIRMED', text: 'Aprovado' },
        { value: 'PROCESSING', text: 'Processando' },
        { value: 'ERROR', text: 'Não aprovado' },
      ],
      user_id_pagarme:null,
      status_pagarme: null,
      user_id_iugu:null,
      status_iugu: null,
      options_gateways: [
        { value: null, text: 'Todos' },
        { value: 'registration', text: 'Cadastrado' },
        { value: 'affiliation', text: 'Afiliação' },
        { value: 'refused', text: 'Recusado' },
        { value: 'suspended', text: 'Suspenso' },
        { value: 'blocked', text: 'Bloqueado' },
        { value: 'inactive', text: 'Inativo' },
        { value: 'active', text: 'Ativo' },
      ],
    }
  },
  computed: {
    dynamicChevron(){
      if(this.collapse){
        return 'transform: rotate(90deg);'
      }
    },
    dateRanges() {
      let today = new Date()
      today.setHours(0, 0, 0, 0)

      let yesterday = new Date()
      yesterday.setDate(today.getDate() - 1)
      yesterday.setHours(0, 0, 0, 0)

      let lastWeek = new Date()
      lastWeek.setDate(today.getDate() - 7)
      lastWeek.setHours(0, 0, 0, 0)

      return {
        Hoje: [today, today],
        Ontem: [yesterday, yesterday],
        'Última semana': [lastWeek, today],
        'Este mês': [
          new Date(today.getFullYear(), today.getMonth(), 1),
          new Date(today.getFullYear(), today.getMonth(), 30)
        ],
        'Este ano': [
          new Date(today.getFullYear(), 0, 1),
          new Date(today.getFullYear(), 11, 31)
        ],
        'Último mês': [
          new Date(today.getFullYear(), today.getMonth() - 1, 1),
          new Date(today.getFullYear(), today.getMonth(), 0)
        ]
      }
    }
  },
  methods: {
    visibleCollapse(){
      if(this.user_id_celcoin || 
      this.status_celcoin || 
      this.user_id_pagarme || 
      this.status_pagarme || 
      this.user_id_iugu || 
      this.status_iugu){
        this.OpenCollapse = true
        return
      }
      this.OpenCollapse = false
    },
    onSubmit() {
      let data = {
        date_start: this.date.startDate
          ? moment(this.date.startDate).format('YYYY-MM-DD')
          : null,
        date_end: this.date.endDate
          ? moment(this.date.endDate).format('YYYY-MM-DD')
          : null,
      }
      if (this.balanceStart) {
        data.balance_start = this.balanceStart
      }
      if (this.balanceEnd) {
        data.balance_end = this.balanceEnd
      }
      if (this.lastMonth) {
        data.lastMonth = this.lastMonth
      }
      if(this.user_id_celcoin){
        data.id_celcoin = this.user_id_celcoin
      }
      if(this.status_celcoin){
        data.status_celcoin = this.status_celcoin
      }
      if(this.user_id_pagarme){
        data.id_pagarme = this.user_id_pagarme
      }
      if(this.status_pagarme){
        data.status_pagarme = this.status_pagarme
      }
      if(this.user_id_iugu){
        data.id_iugu = this.user_id_iugu
      }
      if(this.status_iugu){
        data.status_iugu = this.status_iugu
      }

      this.$emit('close', data)
      this.$bvModal.hide('modal-filters-user')
    }
  }
}
</script>

<style scoped>
.receivers img{
  width: 20px;
  transition: all .3s;
}
.receivers{
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
}
.search_id{
  margin: 0 !important;
}
#range {
  width: 100%;
  height: 45px;
}
</style>